import React from "react";
import ReactDOM from "react-dom";
import { values } from "lodash-es";

import { ILanguageSwitchData } from "types";
import { LanguageSwitch } from "components";

(() => {
  const languageSwitch = document.querySelector<HTMLButtonElement>(
    "[data-language-switch]"
  );

  if (!languageSwitch) return;

  const data = languageSwitch.dataset.languageSwitch;
  languageSwitch.dataset.languageSwitch = ""; // cleanup

  if (!data) return undefined;

  const languageSwitchData = JSON.parse(data) as ILanguageSwitchData;
  const languageSwitchItems = values(languageSwitchData);

  ReactDOM.render(
    <LanguageSwitch items={languageSwitchItems} />,
    languageSwitch
  );
})();

export {};
